import { Directive, ElementRef, EventEmitter, HostListener, Output } from "@angular/core";
import { NgControl } from "@angular/forms";
import { CoreCOMService } from "../../services/com.service";
import { CoreLanguageService } from "../../services/language.service";

@Directive({
  selector: "[formTouchedOnClick]"
})
export class FormTouchedOnClickDirective {

  @Output("input-click") inputClick: EventEmitter<any> = new EventEmitter();

  constructor(private el: ElementRef
    , private control : NgControl
    , private _coreLanguageService: CoreLanguageService
    , private _coreCOMService: CoreCOMService) {

  }

  @HostListener("click", ["$event"])
  public inputOnClick() {
    const me = this;
    me.control["formDirective"].form.markAsTouched()
    me.inputClick.emit()
  }

}